import { useEffect, useRef } from "react";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.min";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.js",
  import.meta.url
).toString();

const PDFViewer = ({ pdfUrl, onRendered }) => {
  const containerRef = useRef(null);
  const renderedRef = useRef(false);

  useEffect(() => {
    if (!pdfUrl || !containerRef.current || renderedRef.current) return;
    renderedRef.current = true;

    const renderPdf = async () => {
      try {
        const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
        const container = containerRef.current;
        container.innerHTML = "";

        const containerWidth = container.clientWidth - 32;
        // const dpr = window.devicePixelRatio || 1;
        const dpr = Math.min(window.devicePixelRatio || 1, 2) * 1.50;
        const SAFE_ZOOM = 0.99;

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);

          // Base viewport
          const baseViewport = page.getViewport({ scale: 1 });

          // Fit to container with safe zoom-out
          const scale =
            (containerWidth / baseViewport.width) * SAFE_ZOOM;

          const viewport = page.getViewport({ scale });

          // Page wrapper
          const pageWrapper = document.createElement("div");
          pageWrapper.style.display = "flex";
          pageWrapper.style.justifyContent = "center";
          pageWrapper.style.marginBottom = "16px";
          pageWrapper.style.background = "#fff";

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          canvas.width = Math.floor(viewport.width * dpr);
          canvas.height = Math.floor(viewport.height * dpr);

          // Visual size
          canvas.style.width = `${viewport.width}px`;
          canvas.style.height = `${viewport.height}px`;
          canvas.style.display = "block";
          canvas.style.background = "#fff";
          canvas.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";

          context.setTransform(dpr, 0, 0, dpr, 0, 0);

          await page.render({
            canvasContext: context,
            viewport
          }).promise;

          pageWrapper.appendChild(canvas);
          container.appendChild(pageWrapper);
        }

        onRendered?.();
      } catch (error) {
        console.error("PDF render failed:", error);
      }
    };

    renderPdf();
  }, [pdfUrl, onRendered]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        padding: "16px",
        background: "#fff",
        overflowX: "hidden"
      }}
    />
  );
};

export default PDFViewer;
